import store from '@/store'
import { resetSessionCountdown } from '@/composables/useSession'

const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } } | undefined)?.response?.status

const rememberSessionExpired = () => {
  try {
    localStorage.setItem('signOutReason', 'sessionExpired')
  } catch {
    return
  }
}

const signOut = () => {
  store.commit({ type: 'setAuthenticatedUser', authenticatedUser: false })
  store.commit({ type: 'setAccessToken', accessToken: '' })
}

export const handleResponseError = (error: unknown): Promise<never> => {
  const status = statusOf(error)

  if (status === 419) {
    rememberSessionExpired()
    signOut()
    resetSessionCountdown()
    location.reload()
  }

  if (status === 401) {
    signOut()
    location.reload()
  }

  if (status === 403) {
    location.href = '/403'
  }

  return Promise.reject(error)
}
